import React from "react";
import { useOutletContext } from "react-router";

const ErrataPage = () => {
    const { model } = useOutletContext();
    const erratas = model?.erratas || [];

    return (
        <div>
            <h1 className="text-3xl font-poppins font-semibold text-primary mb-6">Erratas</h1>

            {erratas.length === 0 && (
                <div className="bg-white rounded-card p-6 text-center">
                    <p className="text-content_2">No erratas at this time.</p>
                </div>
            )}

            <div className="space-y-4">
                {erratas.map((errata, index) => (
                    <div key={index} className="bg-white rounded-card p-5">
                        <div className="flex items-start gap-3">
                            <div className="text-orange mt-0.5 shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M10.29 3.86l-8.6 14.86A1 1 0 002.56 20h18.88a1 1 0 00.87-1.28l-8.6-14.86a1 1 0 00-1.72 0z" />
                                </svg>
                            </div>
                            <div className="min-w-0 flex-1">
                                <h2 className="text-lg font-semibold text-primary font-poppins break-words">{errata.subject}</h2>
                                <p className="text-sm text-content_2 mt-1 whitespace-pre-line break-words">{errata.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ErrataPage;
